import React from 'react';

/** Fixed-height marker for a feed row whose payload could not be rendered safely. */
export function InvalidMessageRow() {
  return (
    <div
      aria-label="Message could not be rendered"
      className="flex h-6 items-center px-4"
      data-invalid-message-row
      role="img"
    >
      <div aria-hidden="true" className="mx-auto h-1 w-full max-w-2xl bg-black" />
    </div>
  );
}
